export const navSidebarWidth = 240;
export const collapsedNavSidebarWidth = 56;
